// example for exporting function
// export const brrt = () => { 
//     alert('brrt');
// }

const Cookies = () => {
}
const moment = require('moment-timezone');
export const isLoggedIn = () => {
  const username = get_cookies('username');
  if(!username){
      window.location.replace(process.env.REACT_APP_BASE_NAME+"/login");
  }
}
export const timeZoneChanger  = (setSelectedDate) =>{
  if (getBranchidno() == "DAVAOHQ") {
    setSelectedDate(moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'));
    }else if(getBranchidno() == "DUBAIHQ"){
    setSelectedDate(moment.tz(new Date(), "Asia/Dubai").format('MMM D YYYY'));
    }else if(getBranchidno() == "NIGERIAHQ"){
      setSelectedDate(moment.tz(new Date(), "Africa/Lagos").format('MMM D YYYY'));
    }else if(getBranchidno() == "TAIWANHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Taipei").format('MMM D YYYY'));
    }else if(getBranchidno() == "CEBUHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Manila").format('MMM D YYYY'));
    }else if(getBranchidno() == "QATARHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Qatar").format('MMM D YYYY'));
    }else if(getBranchidno() == "SINGAPOREHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Singapore").format('MMM D YYYY'));
    }else if(getBranchidno() == "KOREAHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Seoul").format('MMM D YYYY'));
    }else if(getBranchidno() == "OMANHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Muscat").format('MMM D YYYY'));
    }else if(getBranchidno() == "ITALYHQ"){
      setSelectedDate(moment.tz(new Date(), "Europe/Rome").format('MMM D YYYY'));
    }else if(getBranchidno() == "ABUDHABIHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Dubai").format('MMM D YYYY'));
    }else if(getBranchidno() == "KSAHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Riyadh").format('MMM D YYYY'));
    }else if(getBranchidno() == "HONGKONGHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Hong_Kong").format('MMM D YYYY'));
    }else if(getBranchidno() == "MALAYSIAHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Kuala_Lumpur").format('MMM D YYYY'));
    }else if(getBranchidno() == "SPAINHQ"){
      setSelectedDate(moment.tz(new Date(), "Europe/Madrid").format('MMM D YYYY'));
    }
    else if(getBranchidno() == "USAHQ"){
      setSelectedDate(moment.tz(new Date(), "Us/Central").format('MMM D YYYY'));
    }
    else if(getBranchidno() == "AUSTRALIAHQ"){
      setSelectedDate(moment.tz(new Date(), "Australia/Melbourne").format('MMM D YYYY'));
    }
    else if(getBranchidno() == "JAPANHQ"){
      setSelectedDate(moment.tz(new Date(), "Asia/Tokyo").format('MMM D YYYY'));
    }    else if(getBranchidno() == "UGANDAHQ"){
      setSelectedDate(moment.tz(new Date(), "Africa/Kampala").format('MMM D YYYY'));
    }else{
    setSelectedDate(moment.tz(new Date(), "Asia/Manila").format('MMM D YYYY'));
    }
}
export const getCountry  = () =>{
  if (getBranchidno() == "DAVAOHQ") {
    return "PHILIPPINES";
    }else if(getBranchidno() == "DUBAIHQ"){
      return "UNITED ARAB EMIRATES";
    }else if(getBranchidno() == "NIGERIAHQ"){
      return "NIGERIA";
    }else if(getBranchidno() == "TAIWANHQ"){
      return "TAIWAN";
    }else if(getBranchidno() == "CEBUHQ"){
      return "PHILIPPINES";
    }else if(getBranchidno() == "QATARHQ"){
      return "QATAR";
    }else if(getBranchidno() == "SINGAPOREHQ"){
      return "SINGAPORE";
    }else if(getBranchidno() == "KOREAHQ"){
      return "KOREA";
    }else if(getBranchidno() == "OMANHQ"){
      return "OMAN";
    }else if(getBranchidno() == "ITALYHQ"){
      return "ITALY";
    }else if(getBranchidno() == "ABUDHABIHQ"){
      return "UNITED ARAB EMIRATES";
    }else if(getBranchidno() == "KSAHQ"){
      return "KSA";
    }else if(getBranchidno() == "HONGKONGHQ"){
      return "HONG KONG";
    }else if(getBranchidno() == "MALAYSIAHQ"){
      return "MALAYSIA";
    }else if(getBranchidno() == "SPAINHQ"){
      return "SPAIN";
    }
    else if(getBranchidno() == "AUSTRALIAHQ"){
      return "AUSTRALIA";
    }
    else if(getBranchidno() == "USAHQ"){
      return "USA";
    }else if(getBranchidno() == "JAPANHQ"){
      return "JAPAN";
    }else if(getBranchidno() == "UGANDAHQ"){
      return "UGANDA";
    }
    else{
      return "PHILIPPINES";
    }
}

export const time  = (setSelectedTime) =>{
  if (getBranchidno() == "DAVAOHQ") {
    setSelectedTime(moment.tz(new Date(), "Asia/Manila").format('h:mm a'));
    }else if(getBranchidno() == "DUBAIHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Dubai").format('h:mm a'));
    }else if(getBranchidno() == "NIGERIAHQ"){
      setSelectedTime(moment.tz(new Date(), "Africa/Lagos").format('h:mm a'));
    }else if(getBranchidno() == "TAIWANHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Taipei").format('h:mm a'));
    }else if(getBranchidno() == "CEBUHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Manila").format('h:mm a'));
    }else if(getBranchidno() == "QATARHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Qatar").format('h:mm a'));
    }else if(getBranchidno() == "SINGAPOREHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Singapore").format('h:mm a'));
    }else if(getBranchidno() == "KOREAHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Seoul").format('h:mm a'));
    }else if(getBranchidno() == "OMANHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Muscat").format('h:mm a'));
    }else if(getBranchidno() == "ITALYHQ"){
      setSelectedTime(moment.tz(new Date(), "Europe/Rome").format('h:mm a'));
    }else if(getBranchidno() == "ABUDHABIHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Dubai").format('h:mm a'));
    }else if(getBranchidno() == "KSAHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Riyadh").format('h:mm a'));
    }else if(getBranchidno() == "HONGKONGHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Hong_Kong").format('h:mm a'));
    }else if(getBranchidno() == "MALAYSIAHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Kuala_Lumpur").format('h:mm a'));
    }else if(getBranchidno() == "SPAINHQ"){
      setSelectedTime(moment.tz(new Date(), "Europe/Madrid").format('h:mm a'));
    }else if(getBranchidno() == "USAHQ"){
      setSelectedTime(moment.tz(new Date(), "Us/Central").format('h:mm a'));
    }else if(getBranchidno() == "AUSTRALIAHQ"){
      setSelectedTime(moment.tz(new Date(), "Australia/Melbourne").format('h:mm a'));
    }else if(getBranchidno() == "JAPANHQ"){
      setSelectedTime(moment.tz(new Date(), "Asia/Tokyo").format('h:mm a'));
    }else if(getBranchidno() == "UGANDAHQ"){
      setSelectedTime(moment.tz(new Date(), "Africa/Kampala").format('h:mm a'));
    }
    else{
      setSelectedTime(moment.tz(new Date(), "Asia/Manila").format('hh:mm a'));
    }
}

export const timeZoneChange  = (setItem_order_data) =>{
  if (getBranchidno() == "DAVAOHQ") {
    setItem_order_data({
      manufacturing_date:moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'),
      expiration_date:moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'),
      batch_no: ""
    });
    }else if(getBranchidno() == "DUBAIHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Dubai").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Dubai").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "NIGERIAHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Africa/Lagos").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Africa/Lagos").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "CEBUHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "QATARHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Qatar").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Qatar").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "SINGAPOREHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Singapore").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Singapore").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "KOREAHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Seoul").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Seoul").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "OMANHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Muscat").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Muscat").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "ITALYHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Europe/Rome").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Europe/Rome").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "ABUDHABIHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Dubai").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Dubai").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "KSAHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Riyadh").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Riyadh").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "HONGKONGHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Hong_Kong").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Hong_Kong").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "MALAYSIAHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Kuala_Lumpur").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Kuala_Lumpur").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else if(getBranchidno() == "SPAINHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Europe/Madrid").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Europe/Madrid").format('MMM D, yyyy'),
        batch_no: ""
      });
    }
    else if(getBranchidno() == "AUSTRALIAHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Australia/Melbourne").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Australia/Melbourne").format('MMM D, yyyy'),
        batch_no: ""
      });
    }
    else if(getBranchidno() == "USAHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Us/Central").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Us/Central").format('MMM D, yyyy'),
        batch_no: ""
      });
    }
        else if(getBranchidno() == "JAPANHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Asia/Tokyo").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Asia/Tokyo").format('MMM D, yyyy'),
        batch_no: ""
      });
    }        else if(getBranchidno() == "UGANDAHQ"){
      setItem_order_data({
        manufacturing_date:moment.tz(new Date(), "Africa/Kampala").format('MMM D, yyyy'),
        expiration_date:moment.tz(new Date(), "Africa/Kampala").format('MMM D, yyyy'),
        batch_no: ""
      });
    }else{
      setItem_order_data(moment.tz(new Date(), "Asia/Manila").format('MMM D YYYY'));
    }
}



export const getBranchidno = () => {
  const branchidno = get_cookies('branchidno');
  return branchidno;

}

export const getApprove = () => {
  const can_approve = get_cookies('can_approve');
  return can_approve;

}

export const getEdit = () => {
  const can_edit = get_cookies('can_edit');
  return can_edit;

}

export const getDelete = () => {
  const can_delete = get_cookies('can_delete');
  return can_delete;

}

export const getProcess= () => {
  const can_process = get_cookies('can_process');
  return can_process;

}

export const add_cookies = (name, value, hours) =>{
    let expires;
    if (hours) {
        let date = new Date();
        date.setTime(date.getTime()+(hours*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    else{
        expires = "";
    }
    //set cookie
    document.cookie = name+"="+value+expires+";";
    //console.log(name+"="+value+expires+";");
}

export const get_cookies = (name) => {
    var username = getCookie(name);
    //console.log(username);
    return username;
}

export const delete_all_cookies = () => {
  document.cookie = 'user_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'username=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'userrole=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'fullname=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'branchidno=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'main.nav.access=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'content.nav.access=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'position_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'curcode=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
}



const getCookie = (name) => {
  // Add the = sign
  name = name + '=';

  // Get the decoded cookie
  var decodedCookie = decodeURIComponent(document.cookie);

  // Get all cookies, split on ; sign
  var cookies = decodedCookie.split(';');

  // Loop over the cookies
  for (var i = 0; i < cookies.length; i++) {
    // Define the single cookie, and remove whitespace
    var cookie = cookies[i].trim();

    // If this cookie has the name of what we are searching
    if (cookie.indexOf(name) === 0) {
      // Return everything after the cookies name
      return cookie.substring(name.length, cookie.length);
    }
  }
}

export default Cookies;
